import React, { Fragment, useEffect, useState } from "react";
import DirectoryLayout from "../DirectoryLayout";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Table, TableHead, TableBody } from "component/common/Table/index";
import Pagination from "component/common/Pagination";
import { useLocation, useHistory } from "react-router-dom";
import SellerPopUp from "./SellerPopup";
import { getAllSeller, updateSeller } from "service/Directory";
import { Toast } from "utils/toast";
import Loader from "component/common/Loader";
import edit from "assets/images/edit.svg";
import eye from "assets/images/eye.svg";

import styles from "./Seller.module.scss";
import { getRoleAction } from "utils/helper";

const Seller = () => {
  const location = useLocation();

  const history = useHistory();

  const { isOperationAvailable } = getRoleAction("Directory");

  const head = ["Seller Name", "Seller Rating (5)", "Products Sold", ""];

  let [seller, setSeller] = useState(null);

  let [sellerData, setSellerData] = useState([]);

  let [totalPages, setTotalPages] = useState();

  let [isReadOnly, setIsReadOnly] = useState(true);

  let [isOpen, setIsOpen] = useState(false);

  const page = new URLSearchParams(location.search).get("page");

  const search = new URLSearchParams(location.search).get("search");

  useEffect(() => {
    getSeller();
  }, [location.search]);

  const getSeller = async () => {
    let params = {
      page: page != null ? page : 1,
      sellerName: search,
    };
    try {
      let response = await getAllSeller(params);
      if (response.status == 200) {
        setSeller(response.data.data.data);
        setTotalPages(response.data.data.pageMeta.totalPages);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handlePageChange = async (event) => {
    if (search != null) {
      await history.push({
        search: `?search=${search}&page=${event}`,
      });
    } else {
      await history.push({ search: `?page=${event}` });
    }
  };

  const onEdit = (data) => {
    setIsReadOnly(false);
    setSellerData(data);
    toggle();
  };

  const onView = (data) => {
    setIsReadOnly(true);
    setSellerData(data);
    toggle();
  };

  const onSubmit = async (data) => {
    let body = {
      sellerDirectory: data,
    };
    try {
      let response = await updateSeller(body);
      if (response.status == 200) {
        toggle();
        getSeller();
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  if (seller == null) return <Loader />;

  return (
    <>
      <DirectoryLayout page="seller" />
      <Table>
        <TableHead className={styles.seller_head} head={head} />
        <TableBody>
          {seller.length != 0 ? (
            seller?.map((list, index) => {
              return (
                <Fragment key={index}>
                  <tr key={index} className={styles.seller_body}>
                    <td>{list.fullname}</td>
                    <td>{list.rating ? list.rating : "-"}</td>
                    <td>{list.productSold}</td>
                    <td>
                      <UncontrolledDropdown>
                        <DropdownToggle tag="span" data-toggle="dropdown">
                          <i className="icon-dots"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          {isOperationAvailable("View") && (
                            <DropdownItem
                              onClick={() => onView(list.productDetails)}
                            >
                              <div className="dropdown-items">
                                <img src={eye} />
                                <span>View</span>
                              </div>
                            </DropdownItem>
                          )}
                          {isOperationAvailable("Edit") && (
                            <DropdownItem
                              onClick={() => onEdit(list.productDetails)}
                            >
                              <div className="dropdown-items">
                                <img src={edit} />
                                <span>Edit</span>
                              </div>
                            </DropdownItem>
                          )}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan="4" className="no-record">
                No Records Found
              </td>
            </tr>
          )}
        </TableBody>
      </Table>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          activePage={page != null ? page : 1}
          onPageChange={handlePageChange}
        />
      )}
      <SellerPopUp
        isOpen={isOpen}
        toggle={toggle}
        isReadOnly={isReadOnly}
        data={sellerData}
        refresh={getSeller}
        onSave={(e) => onSubmit(e)}
      />
    </>
  );
};

export default Seller;
